import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_autocomplete_filled = _resolveComponent("v-autocomplete-filled")!
  const _component_oss_date_picker_filled = _resolveComponent("oss-date-picker-filled")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[9] || (_cache[9] = _createElementVNode("div", { class: "header" }, "Informations Déclarative", -1)),
    _createVNode(_component_v_form, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { cols: "6" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card, {
                  outlined: "",
                  class: "card"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_title, null, {
                      default: _withCtx(() => _cache[7] || (_cache[7] = [
                        _createTextVNode(" TVA ")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_v_card_actions, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, { cols: "12" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_select_filled, {
                                  modelValue: _ctx.declaration.vatSystem,
                                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.declaration.vatSystem) = $event)),
                                  outlined: "",
                                  "hide-details": "",
                                  label: "Régime TVA",
                                  items: _ctx.vatSystems,
                                  "item-value": "id",
                                  required: "",
                                  density: "compact",
                                  "item-title": (item) => item.name
                                }, null, 8, ["modelValue", "items", "item-title"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, { cols: "12" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_select_filled, {
                                  modelValue: _ctx.declaration.vatDeclarationDay,
                                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.declaration.vatDeclarationDay) = $event)),
                                  outlined: "",
                                  "hide-details": "",
                                  label: "Jour déclaration TVA",
                                  items: _ctx.vatDeclarationDays,
                                  required: "",
                                  density: "compact"
                                }, null, 8, ["modelValue", "items"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, { cols: "12" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_select_filled, {
                                  modelValue: _ctx.declaration.vatOption,
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.declaration.vatOption) = $event)),
                                  outlined: "",
                                  "hide-details": "",
                                  label: "Option de TVA",
                                  items: _ctx.vatOptions,
                                  "item-value": "id",
                                  required: "",
                                  density: "compact",
                                  "item-title": (item) => item.name
                                }, null, 8, ["modelValue", "items", "item-title"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, { cols: "6" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card, {
                  outlined: "",
                  class: "card"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_title, null, {
                      default: _withCtx(() => _cache[8] || (_cache[8] = [
                        _createTextVNode(" Imposition ")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_v_card_actions, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, { cols: "12" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_select_filled, {
                                  modelValue: _ctx.declaration.taxSystemType,
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.declaration.taxSystemType) = $event)),
                                  outlined: "",
                                  "hide-details": "",
                                  label: "Régime fiscal",
                                  items: _ctx.taxSystemTypes,
                                  "item-value": "id",
                                  required: "",
                                  density: "compact",
                                  "item-title": (item) => item.name
                                }, null, 8, ["modelValue", "items", "item-title"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, { cols: "12" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_autocomplete_filled, {
                                  modelValue: _ctx.declaration.sie,
                                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.declaration.sie) = $event)),
                                  items: _ctx.sieList,
                                  outlined: "",
                                  density: "compact",
                                  "hide-details": "",
                                  "item-title": 
                                            (x) => {
                                                return (
                                                    x.city +
                                                    ' - ' +
                                                    x.name +
                                                    ' ' +
                                                    x.postalCode +
                                                    ' ' +
                                                    x.address
                                                );
                                            }
                                        ,
                                  "item-value": "id",
                                  label: "Service des impôts des entreprises"
                                }, null, 8, ["modelValue", "items", "item-title"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, { cols: "6" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_oss_date_picker_filled, {
                                  modelValue: _ctx.declaration.startBusinessDate,
                                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.declaration.startBusinessDate) = $event)),
                                  outlined: "",
                                  dense: "",
                                  "hide-details": "",
                                  label: "Date de début d'activité",
                                  style: {"flex":"1"},
                                  textFieldReadOnly: false
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, { cols: "6" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_oss_date_picker_filled, {
                                  modelValue: _ctx.declaration.firstAccountingPeriodEnd,
                                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.declaration.firstAccountingPeriodEnd) = $event)),
                                  outlined: "",
                                  "hide-details": "",
                                  dense: "",
                                  label: "Date de fin du premier exercice",
                                  style: {"flex":"1"},
                                  textFieldReadOnly: false
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}